import { StrictMode, lazy, type ComponentType } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { applyThemeParams } from "./theme/params";
import { parseDocumentPath } from "./shell/route";
import { loadRenderer } from "./renderers";
import { startEmbedHandshake } from "./services/handshake";
import type { RendererProps } from "./renderers/types";
import { App } from "./shell/App";

// Apply validated theme query params before first paint — no flash of the
// default theme.
applyThemeParams(window.location.search);

const route = parseDocumentPath(window.location.pathname);

let Renderer: ComponentType<RendererProps> | null = null;
if (route) {
  // Eager renderer-chunk kickoff: the import starts now, at module
  // scope, so the chunk download overlaps the ready→auth handshake below.
  const rendererModule = loadRenderer(route.type);
  Renderer = lazy(() => rendererModule);

  // Announce `ready` to the framing host and wait for the API key. The viewer
  // also works top-level (no framing host): with no one to answer, the shell
  // shows the handshake-timeout state after HANDSHAKE_TIMEOUT_MS.
  startEmbedHandshake();
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App route={route} Renderer={Renderer} />
  </StrictMode>,
);
